import { FUNNEL_EMAIL_API } from 'modules/funnels/funnel/components/email-tab/api/funnel-email-api'
import {
  FunnelEmailViewInterface,
  FunnelEmailsApiInterface,
} from 'modules/funnels/funnel/components/email-tab/types/funnel-emails-interface'
import { FunnelStepId } from 'modules/funnels/funnel/types/funnel-step-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { useOnceTrue } from 'shared/hooks/use-once-true'
import useUser from 'shared/hooks/use-user'
import { SwrPaginationInterface } from 'shared/types/pagination-interface'
import { getPaginationQueryString } from 'shared/utils/api/get-pagination-query-string'
import useSWR from 'swr'

interface UseFunnelEmailsInterface extends SwrPaginationInterface {
  funnelStepId?: FunnelStepId
}

export const useFunnelEmails = ({ limit, pagination, funnelStepId }: UseFunnelEmailsInterface) => {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, FunnelEmailsApiInterface>({
    method: RequestMethodsEnum.get,
  })

  return useSWR(() => {
    if (!user || !funnelStepId) return
    if (user) {
      return `${FUNNEL_EMAIL_API}/${funnelStepId}/webinar/emails?${getPaginationQueryString({
        pagination,
        limit,
      })}`
    }
    return null
  }, fetcher)
}

export const useFunnelEmail = (funnelStepId?: FunnelStepId, emailId?: number, opened?: boolean) => {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, FunnelEmailViewInterface>({
    method: RequestMethodsEnum.get,
  })

  const allowed = useOnceTrue(!!user && !!funnelStepId && !!emailId && !!opened)

  const { data: emailData, mutate: mutateEmailData } = useSWR(() => {
    if (!allowed) return
    return `${FUNNEL_EMAIL_API}/${funnelStepId}/webinar/emails/${emailId}`
  }, fetcher)
  return { emailData, mutateEmailData }
}

export const useFunnelEmailInfoSender = (funnelStepId?: FunnelStepId) => {
  const { user } = useUser()
  const { fetcher } = useFetch<
    RequestMethodsEnum.get,
    { senderName: string; senderAddress: string }
  >({ method: RequestMethodsEnum.get })

  return useSWR(() => {
    if (!user || !funnelStepId) return
    return `${FUNNEL_EMAIL_API}/${funnelStepId}/webinar/emails/sender-info`
  }, fetcher)
}
